const ChatIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.8335 5.83301H14.1668V14.1663"
        stroke="#857F8B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7559 5.24408C15.0814 5.56951 15.0814 6.09715 14.7559 6.42259L6.42259 14.7559C6.09715 15.0814 5.56951 15.0814 5.24408 14.7559C4.91864 14.4305 4.91864 13.9028 5.24408 13.5774L13.5774 5.24408C13.9028 4.91864 14.4305 4.91864 14.7559 5.24408Z"
        fill="#857F8B"
      />
    </svg>
  );
};

export default ChatIcon;
